import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

// the three unauthenticated auth pages. Nothing is rendered into the document for
// them any more - what each needs beyond its own url it fetches over the api
export default defineSection({
    // the favicon and the title template for all three; each page names itself
    head: sectionHead(),
    routes: [
        {
            path: '/registration/login/',
            component: () => import(/* webpackChunkName: "authPages" */ './LoginPage.vue'),
            name: 'LoginPage',
        },
        {
            path: '/registration/password_reset_request/',
            component: () => import(/* webpackChunkName: "authPages" */ './ResetPasswordRequestPage.vue'),
            name: 'ResetPasswordRequestPage',
            props: route => ({username: route.query.username || ''}),
        },
        {
            path: '/registration/password_reset/:value/',
            component: () => import(/* webpackChunkName: "authPages" */ './PasswordResetPage.vue'),
            name: 'PasswordResetPage',
            props: true,
        },
    ]
});
